/** Firmware uses degrees per second; one RPM equals 360deg/60s = 6 DPS. */
export const DPS_PER_RPM = 6;

export const MOTOR_PLUS_MOTOR_MODE = {
  velocity: 1,
};

export const MOTOR_PLUS_STOP_MODE = {
  brake: 0,
};

export function rpmToDps(rpm) {
  return rpm * DPS_PER_RPM;
}

export function dpsToRpm(dps) {
  return dps / DPS_PER_RPM;
}

export function signedRpmForDirection(rpm, direction) {
  const magnitude = Math.abs(rpm);
  return direction === 'reverse' ? -magnitude : magnitude;
}

export function extractMotorPlusSettingsUpdate(settings) {
  return {
    targetPosition: settings?.targetPosition ?? 0,
    targetVelocity: settings?.targetVelocity ?? 0,
    targetDuty: settings?.targetDuty ?? 0,
    targetTimeout: settings?.targetTimeout ?? 1,
    targetTolerance: settings?.targetTolerance ?? 1,
    maxTorque: settings?.maxTorque ?? 0,
    polarityInversion: settings?.polarityInversion ?? false,
    stopMode: settings?.stopMode ?? MOTOR_PLUS_STOP_MODE.brake,
    motorMode: settings?.motorMode ?? MOTOR_PLUS_MOTOR_MODE.velocity,
  };
}

export function buildMotorCheckRunSettings(template, signedRpm) {
  const base = extractMotorPlusSettingsUpdate(template);

  return {
    ...base,
    targetVelocity: rpmToDps(signedRpm),
    stopMode: MOTOR_PLUS_STOP_MODE.brake,
    motorMode: MOTOR_PLUS_MOTOR_MODE.velocity,
  };
}

export function buildMotorCheckStopSettings(template) {
  const base = extractMotorPlusSettingsUpdate(template);

  return {
    ...base,
    targetVelocity: 0,
    stopMode: MOTOR_PLUS_STOP_MODE.brake,
    motorMode: MOTOR_PLUS_MOTOR_MODE.velocity,
  };
}

export function buildMotorCheckRestoreSettings(template) {
  const base = extractMotorPlusSettingsUpdate(template);

  return {
    ...base,
    targetVelocity: 0,
  };
}
